import React from 'react';
import { Box } from '@styleseat/ui';
import loadable from '@loadable/component';
import { NAV_BAR_HEIGHT } from '../../shared/BottomNavBar/BottomNavBar';
import { Absolute, Stack } from '../../ui';
import { useIsMobile } from '../../../hooks';
import { Z_NAVIGATION } from '../../ui/utilities/zIndex';
import { useNavigationFilterParams } from './useNavigationFilterParams';
import { TabOption } from '../../provider/tabs/types';

const TopBarNavigation = loadable(() => (
  import('./TopBarNavigation')
), { resolveComponent: mod => mod.TopBarNavigation });

const ProNavBarContainer = loadable(() => (
  import('../../provider/tabs/ProNavBarContainer')
));

type ProviderLayoutProps = {
  children: React.ReactNode;
  providerId: number;
  highlightedTab?: TabOption;
  renderMobileOnlyHeader?: () => React.ReactNode;
  renderHeader?: () => React.ReactNode;
  showMobileNavBar?: boolean;
  hideTopBar?: boolean;
};

export const ProviderLayout: React.FCWithChildren<ProviderLayoutProps> = ({
  children,
  providerId,
  highlightedTab,
  renderMobileOnlyHeader,
  renderHeader,
  showMobileNavBar = true,
  hideTopBar = false,
}) => {
  const isMobile = useIsMobile();
  const navigationFilterParams = useNavigationFilterParams(providerId);
  const willShowTopBar = !isMobile && !hideTopBar;
  return (
    <Absolute
      flexShrink={1}
      flexGrow={1}
      all={0}
    >
      <Box flexGrow={0} flexShrink={0} zIndex={Z_NAVIGATION}>
        <Stack>
          {willShowTopBar && (
            <TopBarNavigation
              providerId={providerId}
              navigationFilterParams={navigationFilterParams}
            />
          )}
          {isMobile && renderMobileOnlyHeader?.()}
          {renderHeader?.()}
        </Stack>
      </Box>

      <Box flexGrow={1} flexShrink={1}>
        {children}
      </Box>

      {(isMobile && showMobileNavBar) ? (
        <Box
          flexGrow={0}
          flexShrink={0}
          style={{ height: NAV_BAR_HEIGHT }}
        >
          <ProNavBarContainer tab={highlightedTab} />
        </Box>
      ) : null}
    </Absolute>
  );
};
